import ofertaDigital from "@/config/brands/ofertaDigital";
import { countSteps } from "@/utils";

jest.mock("../../../utils", () => ({
  countSteps: jest.fn()
}));

describe("ofertaDigital", () => {
  it("should have a googleAnalyticsId", () => {
    expect(ofertaDigital.googleAnalyticsId).toBe("UA-141672014-1");
  });

  it("should have a modulo", () => {
    expect(ofertaDigital.modulo).toBe(process.env.VUE_APP_MODULE_NAME);
  });

  it("should call countSteps when cantPasos is invoked", () => {
    ofertaDigital.cantPasos();
    expect(countSteps).toHaveBeenCalledWith(Object.values(ofertaDigital.pasos));
  });

  it("should have a pasos object", () => {
    expect(typeof ofertaDigital.pasos).toBe("object");
  });

  // Add more tests for the properties of the 'pasos' object as needed
});
